module.exports = __webpack_public_path__ + "static/media/ocp.4a2354e1.png";